module.exports = __webpack_public_path__ + "img/1-Medicion en campo.0b3d9f68.png";